export enum GettinStartedCampaignStepStatus {
  COMPLETED = 'completed',
  SKIPPED = 'skipped',
  MISSED = 'missed',
  CURRENT = 'current',
}
